module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xiaotubiao/备案图标.png
// module id = ckB9
// module chunks = 41